import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { formatString } from "@/core/utils/helpers";
import { CreateOrUpdateApprovalWorkflowDto } from "../dtos/approvalWorkflow.dtos";
import { APPROVAL_WORKFLOW_API_PATHS } from "../constants";

class ApprovalWorkflowService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getApprovalWorkflows(
    organizationId: string,
    isActive?: boolean,
  ): Promise<ICoreResponse> {
    const basePath = formatString(
      APPROVAL_WORKFLOW_API_PATHS.GET_APPROVAL_WORKFLOWS,
      organizationId,
    );
    const url =
      typeof isActive === "boolean"
        ? `${basePath}?is_active=${isActive}`
        : basePath;
    return this.restClient.get(url);
  }

  public getApprovalWorkflowDetail(
    organizationId: string,
    workflowId: string,
  ): Promise<ICoreResponse> {
    return this.restClient.get(
      formatString(
        APPROVAL_WORKFLOW_API_PATHS.GET_APPROVAL_WORKFLOW_DETAIL,
        organizationId,
        workflowId,
      ),
    );
  }

  public createOrUpdateApprovalWorkflow(
    organizationId: string,
    body: CreateOrUpdateApprovalWorkflowDto,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(
        APPROVAL_WORKFLOW_API_PATHS.CREATE_OR_UPDATE_APPROVAL_WORKFLOW,
        organizationId,
      ),
      body,
    );
  }

  public patchApprovalWorkflowStatus(
    organizationId: string,
    workflowId: string,
    isActive: boolean,
  ): Promise<ICoreResponse> {
    return this.restClient.patch(
      formatString(
        APPROVAL_WORKFLOW_API_PATHS.PATCH_APPROVAL_WORKFLOW_STATUS,
        organizationId,
        workflowId,
      ),
      {
        is_active: isActive,
      },
    );
  }

  public deleteApprovalWorkflow(
    organizationId: string,
    publicId: string,
  ): Promise<ICoreResponse> {
    return this.restClient.delete(
      formatString(
        APPROVAL_WORKFLOW_API_PATHS.DELETE_APPROVAL_WORKFLOW,
        organizationId,
        publicId,
      ),
      "",
    );
  }
}

export default ApprovalWorkflowService;
